/* N1 add-ons (Glove ID + Pro Sack + Mini Keychain): visual layer that drives the Infinite Options inputs.
   Infinite Options stays the source of truth (conditional logic, pricing, cart properties).
   Page enhancements (description, tabs, deal bar, sizes, gallery, info popups) run at DOM ready and never wait for the app. */
(function () {
  'use strict';
  if (window.__n1AddonsLoaded) return;
  window.__n1AddonsLoaded = true;

  var PALETTE = {
    'black': '#111111', 'white': '#ffffff', 'gold': 'linear-gradient(135deg,#f3d97a,#c9a227)', 'silver': 'linear-gradient(135deg,#e6e6e6,#a9a9a9)',
    'pink': '#f06ba8', 'royal blue': '#1f47c8', 'blue': '#1f47c8', 'red': '#d61f26', 'rose red': '#b8103f', 'purple': '#6a2fb3',
    'orange': '#f2761b', 'yellow': '#f5e000', 'neon': '#d6f000', 'green': '#1c9a45', 'gray': '#8a8a8a', 'grey': '#8a8a8a'
  };
  var LIGHT = { 'white': 1, 'gold': 1, 'silver': 1, 'yellow': 1, 'neon': 1, 'n1 recommended': 1 };
  var COLOR_STYLES = ['black', 'pink', 'yellow', 'white', 'blue', 'red', 'green', 'orange', 'purple', 'gray', 'grey', 'neon'];

  function q(el, s) { return el.querySelector(s); }
  function qa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }
  function warn(what, e) { if (window.console) console.warn('n1a ' + what, e); }
  function labelText(input, container) {
    var l = input.id ? container.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
    if (!l) { var wrap = fieldWrap(input); l = wrap ? wrap.querySelector('label') : null; }
    return l ? (l.textContent || '').trim() : '';
  }
  function fieldWrap(el) {
    var span = el.closest('span');
    return span && span.parentElement ? span.parentElement : el.parentElement;
  }
  function money(n) { return '$' + n.toFixed(2); }
  function parsePrice(s) { var m = /\$\s*([0-9]+(?:\.[0-9]{1,2})?)/.exec(s || ''); return m ? parseFloat(m[1]) : 0; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ================= Infinite Options mapping ================= */
  function mapIO(container) {
    var radios = qa(container, 'input[type="radio"]');
    var gid = radios.filter(function (r) { return /glove id/i.test(r.name); });
    var sack = radios.filter(function (r) { return /sack/i.test(r.name); });
    var key = radios.filter(function (r) { return /keychain/i.test(r.name) && !/sack/i.test(r.name); });
    // basta haver Glove ID OU Pro Sack: a roupa e os acessórios só têm o saco
    if (!gid.length && !sack.length) return null;
    var texts = qa(container, 'input[type="text"]').filter(function (i) { return !/^note/i.test(i.id || '') && !/not eligible/i.test(labelText(i, container)); });
    var left = texts.filter(function (i) { return /left/i.test(i.id + ' ' + labelText(i, container)); })[0] || texts[0] || null;
    var right = texts.filter(function (i) { return i !== left && /right/i.test(i.id + ' ' + labelText(i, container)); })[0] || texts.filter(function (i) { return i !== left; })[0] || null;
    var colors = radios.filter(function (r) { return gid.indexOf(r) < 0 && sack.indexOf(r) < 0 && key.indexOf(r) < 0; });
    function yes(list) { return list.filter(function (r) { return /^yes/i.test(r.value.trim()); })[0] || null; }
    function no(list) { return list.filter(function (r) { return /^no$/i.test(r.value.trim()); })[0] || null; }
    return {
      gidNo: no(gid), gidYes: yes(gid), left: left, right: right, colors: colors,
      sackNo: no(sack), sackYes: yes(sack), keyNo: no(key), keyYes: yes(key),
      select: q(container, 'select')
    };
  }

  function init(block) {
    if (block.__n1a) return;
    block.__n1a = true;
    var form = block.closest('form');
    if (!form) { block.hidden = true; return; }
    var tries = 0;
    var timer = setInterval(function () {
      // volta a procurar o contentor a cada passagem: a app pode substituí-lo
      var container = q(form, '[id^="infiniteoptions-container"]');
      if (container) {
        var io = mapIO(container);
        if (io && ((io.gidNo && io.gidYes) || (io.sackNo && io.sackYes))) {
          clearInterval(timer);
          try { mount(block, form, container, io); }
          catch (e) { warn('mount', e); block.hidden = true; container.classList.remove('n1a-io-hidden'); }
          return;
        }
      }
      if (++tries > 200) { // app nunca desenhou os campos: devolve o formulário original
        clearInterval(timer); block.hidden = true;
        if (container) container.classList.remove('n1a-io-hidden');
      }
    }, 120);
  }

  function mount(block, form, container, io) {
    var ui = {
      gidCard: q(block, '[data-card="gid"]'), sackCard: q(block, '[data-card="sack"]'), keyCard: q(block, '[data-card="key"]'),
      gidSwitch: q(block, '[data-switch="gid"]'), sackPick: q(block, '[data-switch="sack"]'), keySwitch: q(block, '[data-switch="key"]'), keyPriceEl: q(block, '[data-key-price]'),
      left: q(block, '[data-mirror="left"]'), right: q(block, '[data-mirror="right"]'),
      cntL: q(block, '[data-count="left"]'), cntR: q(block, '[data-count="right"]'),
      swatches: q(block, '[data-swatches]'), colorName: q(block, '[data-color-name]'), colorTag: q(block, '[data-color-tag]'), colorHint: q(block, '[data-color-hint]'),
      tabs: q(block, '[data-tabs]'), chipsN: q(block, '[data-chips="nations"]'), chipsC: q(block, '[data-chips="colors"]'),
      needGid: q(block, '[data-need="gid"]'), needSack: q(block, '[data-need="sack"]'),
      summary: q(block, '[data-summary]'), sumText: q(block, '[data-summary-text]'), sumTotal: q(block, '[data-summary-total]'),
      gidPrice: parsePrice((q(block, '[data-card="gid"] .n1a-plus') || {}).textContent), sackPrice: parsePrice((q(block, '.n1a-value b') || {}).textContent), keyPrice: 0
    };
    var uphead = q(block, '.n1a-uphead'); if (uphead && !q(uphead, 'img')) uphead.classList.add('no-img');
    ui.img = q(block, '[data-sack-img]');

    /* ----- Pro Sack photo per style (map rendered by Liquid from the sack products) ----- */
    var sackImgs = { 'default': '', map: {} };
    try { sackImgs = JSON.parse((q(block, '[data-n1a-sack-images]') || {}).textContent || '{}'); } catch (e) { }
    function sackImage(v) {
      if (!v) return sackImgs['default'];
      var map = sackImgs.map || {}, lv = v.toLowerCase().trim();
      if (map[v]) return map[v];
      var keys = Object.keys(map);
      var k = keys.filter(function (x) { return x.toLowerCase() === lv; })[0] || keys.filter(function (x) { return x.toLowerCase().indexOf(lv + ' ') === 0; })[0] || keys.filter(function (x) { return x.toLowerCase().indexOf(lv) >= 0; })[0];
      return k ? map[k] : sackImgs['default'];
    }

    /* ----- mirror limits from the app ----- */
    function mirrorLimits() {
      [['left', io.left, ui.left, ui.cntL], ['right', io.right, ui.right, ui.cntR]].forEach(function (p) {
        if (!p[1] || !p[2]) return;
        var max = parseInt(p[1].getAttribute('maxlength'), 10);
        if (max > 0) { p[2].setAttribute('maxlength', max); if (p[3]) p[3].hidden = false; } else if (p[3]) p[3].hidden = true;
        if (p[1].placeholder) p[2].placeholder = p[1].placeholder;
      });
      if (io.keyYes) { ui.keyPrice = parsePrice(io.keyYes.value); if (ui.keyPriceEl && ui.keyPrice) ui.keyPriceEl.textContent = '+ ' + money(ui.keyPrice); }
    }
    mirrorLimits();

    /* ----- build swatches from the app's color radios (by value: the app may re-create its inputs) ----- */
    function buildSwatches() {
      if (!ui.swatches) return;
      ui.swatches.innerHTML = '';
      io.colors.forEach(function (r) {
        var name = r.value.trim(); var key = name.toLowerCase(); var rec = /recommend/.test(key);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'n1a-swatch' + (rec ? ' is-rec' : ''); b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', name); b.dataset.value = r.value;
        if (LIGHT[key] || rec) b.style.setProperty('--n1a-chk', '#111');
        var dot = document.createElement('span'); dot.className = 'n1a-dot';
        if (!rec) dot.style.background = PALETTE[key] || '#bdbdbd';
        var nm = document.createElement('span'); nm.className = 'n1a-nm'; nm.textContent = rec ? 'Recommended' : name;
        b.appendChild(dot); b.appendChild(nm); ui.swatches.appendChild(b);
      });
    }
    buildSwatches();
    function colorByValue(v) { return io.colors.filter(function (r) { return r.value === v; })[0] || null; }

    /* ----- build style chips from the app's select ----- */
    var styler = ui.sackCard ? q(ui.sackCard, '[data-styler]') : null, nostyle = ui.sackCard ? q(ui.sackCard, '[data-nostyle]') : null;
    function buildChips() {
      if (!ui.sackCard) return;
      ui.chipsN.innerHTML = ''; ui.chipsC.innerHTML = '';
      if (styler) styler.hidden = !io.select; if (nostyle) nostyle.hidden = !!io.select;
      if (!io.select) {
        ui.tabs.hidden = true;
        // "Matching Nations" option set: no style chooser, the app matches the glove's nation
        var lbl = io.sackYes ? (fieldWrap(io.sackYes).querySelector('label') || {}).textContent || '' : '';
        if (/matching/i.test(lbl)) { var t = q(ui.sackCard, '.n1a-title'), st = q(ui.sackCard, '.n1a-sub'); if (t) t.textContent = 'Matching Nations Pro Sack + Keychain'; if (st) st.textContent = "A Pro Sack in your glove's nation, plus a mini glove keychain."; }
        return;
      }
      qa(io.select, 'option').forEach(function (o) {
        var v = o.value.trim(); if (!v || /^select/i.test(o.textContent.trim())) return;
        var isColor = COLOR_STYLES.indexOf(v.toLowerCase()) >= 0;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'n1a-chip'; b.setAttribute('aria-pressed', 'false'); b.dataset.value = o.value;
        if (isColor) { var c = document.createElement('span'); c.className = 'n1a-c'; c.style.background = PALETTE[v.toLowerCase()] || '#bdbdbd'; b.appendChild(c); }
        b.appendChild(document.createTextNode(o.textContent.trim()));
        (isColor ? ui.chipsC : ui.chipsN).appendChild(b);
      });
      var hasN = ui.chipsN.children.length > 0, hasC = ui.chipsC.children.length > 0;
      ui.tabs.hidden = !(hasN && hasC);
      if (!hasN && hasC) { ui.chipsN.hidden = true; ui.chipsC.hidden = false; }
    }
    buildChips();

    /* ----- state helpers (the app is the source of truth) ----- */
    function gidOn() { return !!(io.gidYes && io.gidYes.checked); }
    function sackOn() { return !!(io.sackYes && io.sackYes.checked); }
    function keyOn() { return !!(io.keyYes && io.keyYes.checked); }
    function styleVal() { return io.select ? io.select.value : ''; }
    function colorRadio() { return io.colors.filter(function (r) { return r.checked; })[0] || null; }

    function refresh() {
      var g = gidOn(), s = sackOn(), k = keyOn();
      if (ui.gidCard) {
        ui.gidCard.hidden = !io.gidYes;                 // roupa/acessórios: não há Glove ID
        ui.gidCard.classList.toggle('is-on', g);
        ui.gidSwitch.setAttribute('aria-checked', g ? 'true' : 'false');
      }
      if (!io.gidYes) {                                  // só o cartão do saco
        if (ui.sackCard) {
          ui.sackCard.hidden = !io.sackYes;
          ui.sackCard.classList.toggle('is-on', s); ui.sackPick.setAttribute('aria-checked', s ? 'true' : 'false');
          q(ui.sackPick, '.n1a-pick-txt').textContent = s ? ui.sackPick.dataset.txtOn : ui.sackPick.dataset.txtOff;
          if (s || !styleVal()) { ui.needSack.hidden = !(s && io.select && !styleVal() && ui.sackCard.classList.contains('is-error')); }
        }
        if (ui.keyCard) ui.keyCard.hidden = !io.keyYes;
        var sv0 = styleVal();
        qa(block, '.n1a-chip').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.value === sv0 && sv0 ? 'true' : 'false'); });
        var parts0 = [], total0 = 0;
        if (s) { var st0 = io.select ? (sv0 ? esc(optionText(sv0)) : 'choose a style') : 'matching nation'; parts0.push('Pro Sack <b>' + st0 + '</b> + keychain'); total0 += ui.sackPrice; }
        if (k) { parts0.push('Mini Glove Keychain'); total0 += ui.keyPrice; }
        ui.summary.hidden = !parts0.length;
        ui.sumText.innerHTML = parts0.join(' · ');
        ui.sumTotal.textContent = 'Extras ' + money(total0);
        if (ui.img) { var src0 = sackImage(s ? sv0 : ''); if (src0 && ui.img.getAttribute('src') !== src0) ui.img.src = src0; }
        return;
      }
      if (ui.sackCard) {
        ui.sackCard.hidden = !io.sackYes;
        ui.sackCard.classList.toggle('is-on', s); ui.sackPick.setAttribute('aria-checked', s ? 'true' : 'false');
        q(ui.sackPick, '.n1a-pick-txt').textContent = s ? ui.sackPick.dataset.txtOn : ui.sackPick.dataset.txtOff;
      }
      if (ui.keyCard) { ui.keyCard.hidden = !io.keyYes; ui.keyCard.classList.toggle('is-on', k); if (ui.keySwitch) ui.keySwitch.setAttribute('aria-checked', k ? 'true' : 'false'); }
      if (io.left && ui.left && document.activeElement !== ui.left) ui.left.value = io.left.value;
      if (io.right && ui.right && document.activeElement !== ui.right) ui.right.value = io.right.value;
      if (ui.cntL && !ui.cntL.hidden) ui.cntL.textContent = ui.left.value.length + '/' + ui.left.getAttribute('maxlength');
      if (ui.cntR && !ui.cntR.hidden) ui.cntR.textContent = ui.right.value.length + '/' + ui.right.getAttribute('maxlength');
      var cr = colorRadio();
      qa(ui.swatches, '.n1a-swatch').forEach(function (b) { b.setAttribute('aria-pressed', cr && b.dataset.value === cr.value ? 'true' : 'false'); });
      var cname = cr ? cr.value.trim() : '';
      var rec = /recommend/i.test(cname);
      ui.colorName.textContent = rec ? 'N1 Recommended' : cname;
      ui.colorTag.hidden = !rec;
      ui.colorHint.textContent = rec ? '— we pick the color that contrasts best with this glove.' : '— tip: pick a color that contrasts with your glove.';
      var sv = styleVal();
      qa(block, '.n1a-chip').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.value === sv && sv ? 'true' : 'false'); });
      if (!g) { ui.needGid.hidden = true; ui.gidCard.classList.remove('is-error'); }
      if (ui.sackCard && (!s || sv)) { ui.needSack.hidden = true; ui.sackCard.classList.remove('is-error'); }
      // summary
      var parts = [], total = 0;
      if (g) { parts.push('Glove ID <b>' + esc((io.left && io.left.value) || '—') + ' / ' + esc((io.right && io.right.value) || '—') + '</b> · ' + esc(ui.colorName.textContent)); total += ui.gidPrice; }
      if (s) { var st = io.select ? (sv ? esc(optionText(sv)) : 'choose a style') : 'matching nation'; parts.push('Pro Sack <b>' + st + '</b> + keychain'); total += ui.sackPrice; }
      if (k) { parts.push('Mini Glove Keychain'); total += ui.keyPrice; }
      ui.summary.hidden = !parts.length;
      ui.sumText.innerHTML = parts.join(' · ');
      ui.sumTotal.textContent = 'Extras ' + money(total);
      if (ui.img) { var src = sackImage(s ? sv : ''); if (src && ui.img.getAttribute('src') !== src) ui.img.src = src; }
    }
    function optionText(v) { var o = io.select ? qa(io.select, 'option').filter(function (x) { return x.value === v; })[0] : null; return o ? o.textContent.trim() : v; }

    /* ----- drive the app ----- */
    function setGid(on) { var r = on ? io.gidYes : io.gidNo; if (r && !r.checked) { r.click(); fire(r, 'change'); } refresh(); if (on && ui.left) setTimeout(function () { ui.left.focus(); }, 80); }
    // ao ligar o Pro Sack fica logo escolhido USA (o cliente pode trocar); o app pode recriar o select, por isso repete-se
    function sackDefault() {
      if (!io.select || io.select.value) return;
      var def = qa(io.select, 'option').filter(function (o) { return /^\s*usa\s*$/i.test(o.value) || /^\s*usa\s*$/i.test(o.textContent); })[0];
      if (def) { io.select.value = def.value; fire(io.select, 'change'); refresh(); }
    }
    function setSack(on) {
      var r = on ? io.sackYes : io.sackNo;
      if (r && !r.checked) { r.click(); fire(r, 'change'); }
      if (!on && io.select) { io.select.value = ''; fire(io.select, 'change'); }
      if (on) { sackDefault(); setTimeout(sackDefault, 250); setTimeout(sackDefault, 700); }
      refresh();
    }
    function setKey(on) { var r = on ? io.keyYes : io.keyNo; if (r && !r.checked) { r.click(); fire(r, 'change'); } refresh(); }
    function setText(which, v) { var t = which === 'left' ? io.left : io.right; if (!t) return; t.value = v; fire(t, 'input'); fire(t, 'change'); refresh(); }
    function setColor(r) { if (r && !r.checked) { r.click(); fire(r, 'change'); } refresh(); }
    function setStyle(v) { if (!io.select) return; io.select.value = v; fire(io.select, 'change'); refresh(); }

    /* ----- UI events ----- */
    qa(block, '[data-toggle]').forEach(function (h) {
      h.addEventListener('click', function (e) {
        if (e.target.closest('a, [data-n1a-open]')) return;
        var key = h.dataset.toggle, sw = e.target.closest('[data-switch]');
        var on = sw ? sw.getAttribute('aria-checked') !== 'true' : true;
        var isOn = key === 'gid' ? gidOn() : key === 'sack' ? sackOn() : keyOn();
        if (!sw && isOn) return;
        if (key === 'gid') setGid(on); else if (key === 'sack') setSack(on); else setKey(on);
      });
    });
    if (ui.left) ui.left.addEventListener('input', function () { setText('left', ui.left.value); });
    if (ui.right) ui.right.addEventListener('input', function () { setText('right', ui.right.value); });
    ui.swatches.addEventListener('click', function (e) { var b = e.target.closest('.n1a-swatch'); if (b) setColor(colorByValue(b.dataset.value)); });
    block.addEventListener('click', function (e) { var c = e.target.closest('.n1a-chip'); if (c) setStyle(c.dataset.value); });
    if (ui.tabs) qa(ui.tabs, '[role="tab"]').forEach(function (t) {
      t.addEventListener('click', function () {
        qa(ui.tabs, '[role="tab"]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        ui.chipsN.hidden = t.dataset.tab !== 'nations'; ui.chipsC.hidden = t.dataset.tab !== 'colors';
      });
    });

    /* ----- keep in sync if the app changes on its own (re-render, variant change) ----- */
    container.addEventListener('change', function () { refresh(); });
    new MutationObserver(function () {
      var fresh = mapIO(container);
      if (fresh && fresh.gidNo && fresh.gidYes) { io = fresh; mirrorLimits(); buildChips(); buildSwatches(); refresh(); }
      if (!container.classList.contains('n1a-io-hidden')) container.classList.add('n1a-io-hidden');
    }).observe(container, { childList: true, subtree: true });

    /* ----- validation mirror before add to cart ----- */
    function validate() {
      var ok = true;
      if (gidOn()) {
        var needL = io.left && (io.left.required || io.left.getAttribute('aria-required') === 'true');
        var needR = io.right && (io.right.required || io.right.getAttribute('aria-required') === 'true');
        var missing = (needL && !io.left.value.trim()) || (needR && !io.right.value.trim()) || (!needL && !needR && !(io.left && io.left.value.trim()) && !(io.right && io.right.value.trim()));
        if (missing) { ok = false; ui.needGid.hidden = false; ui.gidCard.classList.add('is-error'); }
      }
      if (ui.sackCard && sackOn() && io.select && !styleVal()) { ok = false; ui.needSack.hidden = false; ui.sackCard.classList.add('is-error'); }
      if (!ok) {
        var first = q(block, '.n1a-card.is-error');
        if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var campo = [ui.left, ui.right].filter(function (i) { return i && !i.value.trim(); })[0];
        if (campo) setTimeout(function () { try { campo.focus({ preventScroll: true }); } catch (e) { campo.focus(); } }, 320);
      }
      return ok;
    }
    /* A trava tem de correr ANTES de qualquer outro código (tema, app de carrinho fixo, Infinite Options).
       Um listener no próprio botão não chega: quem foi registado primeiro nesse botão dispara primeiro, e há
       mais do que um botão "adicionar ao carrinho" na página. Um listener em captura no documento corre
       sempre primeiro, seja qual for o botão clicado. */
    block.__n1aValidate = validate; // a trava global (installGuard) usa esta validação quando a camada está viva

    /* ----- go live ----- */
    container.classList.add('n1a-io-hidden');
    block.classList.remove('is-busy');
    block.hidden = false;
    refresh();
  }

  /* ================= Page enhancements (independent from the app) ================= */
  function enhancePage(section) {
    if (!section || section.__n1aPage) return;
    section.__n1aPage = true;
    section.classList.add('n1a-on');
    var stickyCol = q(section, '.product-single__sticky'); if (stickyCol) stickyCol.classList.add('n1a-nosticky');
    var atcBtn = q(section, '[data-add-to-cart], button[name="add"]');
    if (atcBtn) atcBtn.addEventListener('click', function () { atcBtn.classList.add('is-pressed'); setTimeout(function () { atcBtn.classList.remove('is-pressed'); }, 900); });
    try { enhanceDescription(section); } catch (e) { warn('description', e); }
    try { enhanceInfoTabs(section); } catch (e) { warn('tabs', e); }
    try { enhanceDeal(section); } catch (e) { warn('deal', e); }
    try { enhanceSizes(section); } catch (e) { warn('sizes', e); }
    try { enhanceGallery(section); } catch (e) { warn('gallery', e); }
    try { enhanceReviews(); } catch (e) { warn('reviews', e); }
  }

  /* ================= Description: spec grid + feature accordion (progressive, nodes are moved, never lost) ================= */
  var IC = {
    palm: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M7 21V9a4 4 0 0 1 8 0v2"/><path d="M11 11V6a2 2 0 1 1 4 0v5"/><path d="M15 11V7a2 2 0 1 1 4 0v9a6 6 0 0 1-6 6h-1"/><path d="M7 14l-2-2a2 2 0 0 0-3 3l5 6"/></svg>',
    cut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.5 15.5M8.5 8.5 20 20"/></svg>',
    wrist: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="8" width="18" height="8" rx="4"/><path d="M7 12h10"/></svg>',
    strap: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 9h16v6H4z"/><path d="M8 9V6a4 4 0 0 1 8 0v3M9 12h.01M12 12h.01M15 12h.01"/></svg>',
    backhand: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 3 4 6v6c0 5 3.4 8.4 8 9 4.6-.6 8-4 8-9V6l-8-3z"/></svg>',
    body: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 8h11a3 3 0 1 0-3-3M3 13h15a3 3 0 1 1-3 3M3 18h7"/></svg>',
    fingersave: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M9 21V7a3 3 0 0 1 6 0v14"/><path d="M6 21h12"/></svg>',
    def: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2"/></svg>'
  };
  function specFromText(t) {
    var m = /^([A-Za-z][A-Za-z +&®\/]{1,26}?)\s*[-–—:]\s*(.+)$/.exec(t);
    return m ? { label: m[1].trim().toUpperCase(), value: m[2].trim() } : null;
  }
  function isHeadingEl(p) {
    if (/^H[2-4]$/.test(p.tagName)) return p.textContent.trim().length > 2;
    if (p.tagName !== 'P') return false;
    var s = p.firstElementChild; if (!s || (s.tagName !== 'STRONG' && s.tagName !== 'B')) return false;
    var before = ''; var n = p.firstChild; while (n && n !== s) { before += n.textContent || ''; n = n.nextSibling; }
    return !before.trim() && s.textContent.trim().length > 2;
  }
  // "<p><strong>A</strong><br>text<br><br><strong>B</strong><br>text</p>" → one <p> per bold heading
  function splitParagraph(p) {
    if (p.tagName !== 'P') return [p];
    var strongs = qa(p, ':scope > strong, :scope > b'); if (strongs.length < 2) return [p];
    var groups = [], cur = null, prevBr = true;
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      var isStrong = n.nodeType === 1 && (n.tagName === 'STRONG' || n.tagName === 'B');
      if (isStrong && prevBr) { cur = []; groups.push(cur); }
      if (!cur) { cur = []; groups.push(cur); }
      cur.push(n);
      if (n.nodeType === 1 && n.tagName === 'BR') prevBr = true; else if (!(n.nodeType === 3 && !n.textContent.trim())) prevBr = false;
    });
    if (groups.length < 2) return [p];
    var out = groups.map(function (g) { var np = document.createElement('p'); g.forEach(function (n) { np.appendChild(n); }); return np; });
    out.forEach(function (np) { p.parentNode.insertBefore(np, p); }); p.parentNode.removeChild(p);
    return out;
  }
  function buildDescription(rte) {
    var kids = Array.prototype.slice.call(rte.children);
    function findUl(list) { for (var i = 0; i < list.length; i++) { if (list[i].tagName === 'UL' && qa(list[i], 'li').length >= 3) return i; } return -1; }
    var ulIdx = findUl(kids);
    if (ulIdx < 0) { // some descriptions come wrapped in a <div>: work inside that wrapper
      var ul = qa(rte, 'ul').filter(function (u) { return qa(u, 'li').length >= 3; })[0];
      if (!ul || !ul.parentElement || ul.parentElement === rte) return false;
      rte = ul.parentElement; kids = Array.prototype.slice.call(rte.children); ulIdx = findUl(kids);
      if (ulIdx < 0) return false;
    }
    var specs = qa(kids[ulIdx], 'li').map(function (li) { return specFromText(li.textContent.replace(/\s+/g, ' ').trim()); }).filter(Boolean);
    if (specs.length < 3) return false;
    var flow = [];
    kids.slice(0, ulIdx).forEach(function (el) { if (el.textContent.trim() || q(el, 'img')) { el.classList.add('n1a-lead'); flow.push(el); } });
    var grid = document.createElement('div'); grid.className = 'n1a-specs';
    specs.forEach(function (it) {
      var key = it.label.toLowerCase().replace(/[^a-z]/g, '');
      var tile = document.createElement('div'); tile.className = 'n1a-spec';
      tile.innerHTML = '<span class="n1a-spec-ic">' + (IC[key] || IC.def) + '</span><span class="n1a-spec-l">' + esc(it.label) + '</span><span class="n1a-spec-v">' + esc(it.value) + '</span>';
      grid.appendChild(tile);
    });
    flow.push(grid);
    var rest = [];
    kids.slice(ulIdx + 1).forEach(function (el) { splitParagraph(el).forEach(function (x) { rest.push(x); }); });
    var lead = null, acc = null, current = null, reco = null;
    rest.forEach(function (el) {
      if (isHeadingEl(el)) {
        var strong = el.tagName === 'P' ? el.firstElementChild : null;
        var title = (strong ? strong.textContent : el.textContent).replace(/\s+/g, ' ').replace(/[:\s]+$/, '').trim();
        var body = document.createElement('div');
        if (strong) { var n = strong.nextSibling; while (n) { var nx = n.nextSibling; if (!(n.nodeType === 1 && n.tagName === 'BR' && !body.childNodes.length) && !(n.nodeType === 3 && !n.textContent.trim() && !body.childNodes.length)) body.appendChild(n); n = nx; } }
        if (/recommended for/i.test(title)) {
          reco = document.createElement('div'); reco.className = 'n1a-reco';
          reco.innerHTML = '<span class="n1a-reco-l">' + esc(title) + '</span>';
          var rb = document.createElement('div'); rb.className = 'n1a-reco-b'; if (body.textContent.trim()) rb.appendChild(body); reco.appendChild(rb);
          current = rb; return;
        }
        if (!acc) { acc = document.createElement('div'); acc.className = 'n1a-acc'; flow.push(acc); }
        var item = document.createElement('details'); item.className = 'n1a-acc-item'; if (!acc.children.length) item.open = true;
        var sum = document.createElement('summary'); sum.innerHTML = '<span>' + esc(title) + '</span><i aria-hidden="true"></i>'; item.appendChild(sum);
        var b = document.createElement('div'); b.className = 'n1a-acc-body'; if (body.textContent.trim()) b.appendChild(body); item.appendChild(b);
        acc.appendChild(item); current = b; return;
      }
      if (!el.textContent.trim() && !q(el, 'img')) return; // empty paragraph
      if (!lead && !current && el.tagName === 'P') { lead = el; lead.classList.add('n1a-lead'); flow.push(lead); return; }
      if (current) { current.appendChild(el); return; }
      flow.push(el);
    });
    if (reco) flow.push(reco);
    while (rte.firstChild) rte.removeChild(rte.firstChild);
    var wrap = document.createElement('div'); wrap.className = 'n1a-desc';
    flow.forEach(function (n) { wrap.appendChild(n); });
    rte.appendChild(wrap);
    if (acc) acc.addEventListener('toggle', function (e) { // one open at a time
      if (e.target.open) qa(acc, 'details').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
    return true;
  }
  function enhanceDescription(section) {
    var rte = q(section, '[id^="Product-description-"] .rte') || q(section, '.product-single__description.rte');
    if (!rte || rte.__n1aDone) return;
    rte.__n1aDone = true;
    try { buildDescription(rte); } finally { rte.classList.add('n1a-desc-ready'); }
  }
  window.__n1aBuildDescription = buildDescription; // test hook

  /* ================= Size Guide / Warranty / Glove Care: fallback for "Click HERE" pages not handled by Liquid ================= */
  var LINK_META = [
    [/base-layer|clothing|apparel|baselayer/i, 'Clothing size guide', 'Baselayer and apparel measurements.', 'clothing-size'],
    [/size-guide|size guide/i, 'Glove size guide', 'Find your perfect fit by hand size.', 'glove-size'],
    [/satisfaction|guarantee|warranty/i, '100% Satisfaction Guarantee', '30 days, no questions asked. See how it works.', 'warranty'],
    [/glove-care|care/i, 'Glove care guide', 'Make your latex last longer, save after save.', 'care']
  ];
  function enhanceInfoTabs(section) {
    for (var n = 1; n <= 3; n++) {
      var rte = q(section, '[id^="Product-content-' + n + '-"] .rte');
      if (!rte || rte.__n1aDone || q(rte, '.n1a-linkcard')) continue;
      var anchors = qa(rte, 'a'); if (!anchors.length) continue;
      if (!q(rte, 'p')) { var p = document.createElement('p'); while (rte.firstChild) p.appendChild(rte.firstChild); rte.appendChild(p); }
      var changed = false;
      qa(rte, 'p').forEach(function (par) {
        var a = q(par, 'a'); if (!a || qa(par, 'a').length !== 1) return;
        var text = par.textContent.replace(/\s+/g, ' ').trim();
        if (!/click\s+here/i.test(text) && !/^here$/i.test(a.textContent.trim())) return;
        var probe = (a.getAttribute('href') || '') + ' ' + text; var meta = null;
        for (var i = 0; i < LINK_META.length; i++) { if (LINK_META[i][0].test(probe)) { meta = LINK_META[i]; break; } }
        var title = meta ? meta[1] : text.replace(/click\s+here\s*(to|for)?\s*(our|find out about|learn how to)?\s*/i, '').replace(/\.$/, '').trim();
        var sub = meta ? meta[2] : '';
        var hasModal = meta && document.querySelector('.n1m[data-n1a-modal="' + meta[3] + '"]');
        var card = document.createElement(hasModal ? 'button' : 'a'); card.className = 'n1a-linkcard';
        if (hasModal) { card.type = 'button'; card.setAttribute('data-n1a-open', meta[3]); } else { card.href = a.href; if (a.target) card.target = a.target; if (a.rel) card.rel = a.rel; }
        card.innerHTML = '<span class="n1a-linkcard-ic">' + IC.def + '</span><span class="n1a-linkcard-t"><b>' + esc(title.charAt(0).toUpperCase() + title.slice(1)) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span><span class="n1a-linkcard-a" aria-hidden="true">&rarr;</span>';
        par.parentNode.replaceChild(card, par); changed = true;
      });
      if (changed) { rte.__n1aDone = true; rte.classList.add('n1a-links'); }
    }
  }

  /* ================= Price block: "2 ITEMS=20%OFF / 3 ITEMS=25%OFF" → deal chips (fallback when Liquid did not render it) ================= */
  function enhanceDeal(section) {
    var note = q(section, '.product-single__prices .product__note');
    if (note && !note.__n1aDone && !note.classList.contains('n1a-deal')) {
      var parts = note.textContent.split('/').map(function (s) { return s.trim(); }).filter(Boolean);
      var chips = parts.map(function (s) { var m = /^(\d+\+?)\s*items?\s*=\s*(\d+)\s*%\s*off$/i.exec(s); return m ? { q: m[1], p: m[2] } : null; });
      if (chips.length && !chips.some(function (c) { return !c; })) {
        note.__n1aDone = true; note.classList.add('n1a-deal');
        note.innerHTML = '<span class="n1a-deal-l"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>Stack &amp; save</span>' +
          '<span class="n1a-deal-chips">' + chips.map(function (c) { return '<span class="n1a-deal-c"><b>' + esc(c.q) + ' items</b><em>&minus;' + esc(c.p) + '%</em></span>'; }).join('') + '</span>';
      }
    }
    // "Shipping calculated at checkout": abre o popup de envios (sem JS continua a ir à página da política)
    var polLink = q(section, '.product__policies a');
    if (polLink && !polLink.getAttribute('data-n1a-open') && document.querySelector('.n1m[data-n1a-modal="shipping"]')) {
      polLink.setAttribute('data-n1a-open', 'shipping');
    }
    var pol = q(section, '.product__policies');
    if (pol && !pol.__n1aDone && !pol.classList.contains('n1a-policies')) {
      pol.__n1aDone = true; pol.classList.add('n1a-policies');
      var inner = document.createElement('span'); while (pol.firstChild) inner.appendChild(pol.firstChild);
      pol.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';
      pol.appendChild(inner);
    }
  }

  /* ================= Size buttons: size guide shortcut (fallback when Liquid did not render it) ================= */
  function enhanceSizes(section) {
    var wrap = q(section, '.variant-wrapper'); if (!wrap || wrap.__n1aDone || q(wrap, '.n1a-sizelink')) return;
    var label = q(wrap, '.variant__label'); if (!label) return;
    wrap.__n1aDone = true;
    var link = document.createElement('button'); link.type = 'button'; link.className = 'n1a-sizelink'; link.textContent = 'Size guide';
    var glove = document.querySelector('.n1m[data-n1a-modal="glove-size"]');
    if (glove) { link.setAttribute('data-n1a-open', 'glove-size'); }
    else {
      var tab = qa(section, '.collapsible-trigger--tab').filter(function (t) { return /size/i.test(t.textContent); })[0];
      if (!tab) return;
      link.addEventListener('click', function (e) { e.preventDefault(); if (!tab.classList.contains('is-open')) tab.click(); setTimeout(function () { tab.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120); });
    }
    label.appendChild(link);
  }

  /* ================= Gallery (mobile): thumbnails under the photo, current thumb in sync ================= */
  function enhanceGallery(section) {
    var thumbs = q(section, '[data-product-thumbs]'), photos = q(section, '[data-product-photos]');
    if (!thumbs || !photos || thumbs.__n1aDone) return;
    thumbs.__n1aDone = true; thumbs.classList.add('n1a-thumbs');
    function sync() {
      var cur = q(photos, '.slick-current[data-index]') || q(photos, '.slick-current');
      var idx = cur ? String(cur.getAttribute('data-index')) : null; if (idx === null) return;
      qa(thumbs, '[data-product-thumb-item]').forEach(function (t) {
        var on = String(t.getAttribute('data-index')) === idx; t.classList.toggle('thumb--current', on);
        if (on && t.scrollIntoView && window.innerWidth < 769) { try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) { t.scrollIntoView(); } }
      });
    }
    new MutationObserver(sync).observe(photos, { attributes: true, subtree: true, attributeFilter: ['class'] });
    sync();
    // the theme ignores thumbnail clicks on small screens: drive the slider ourselves
    var $ = window.jQuery;
    function slider() { $ = $ || window.jQuery; return $ && $(photos).hasClass('slick-initialized') ? $(photos) : null; }
    thumbs.addEventListener('click', function (e) {
      var a = e.target.closest('[data-product-thumb]'); if (!a || window.innerWidth >= 769) return;
      e.preventDefault(); e.stopPropagation();
      var item = a.closest('[data-product-thumb-item]'); var idx = item ? parseInt(item.getAttribute('data-index'), 10) : NaN;
      var s = slider(); if (s && !isNaN(idx)) s.slick('slickGoTo', idx);
    }, true);
    function relayout() { var s = slider(); if (s) s.slick('setPosition'); }
    setTimeout(relayout, 60); setTimeout(relayout, 600); setTimeout(relayout, 1500);
    window.addEventListener('resize', function () { setTimeout(relayout, 60); });
  }

  /* ================= Reviews: iniciais do cliente no círculo do avatar =================
     O Judge.me deixa o círculo vazio quando a pessoa não tem foto, e com o nosso fundo preto ficava
     uma bola preta. Pomos as iniciais do nome (só leitura, não inventa fotos de ninguém). */
  function enhanceReviews() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root || root.__n1aRev) return;
    root.__n1aRev = true;
    function iniciais(nome) {
      var p = String(nome || '').trim().split(/\s+/).filter(Boolean);
      if (!p.length) return '';
      var a = p[0].charAt(0);
      var b = p.length > 1 ? p[p.length - 1].charAt(0) : '';
      return (a + b).toUpperCase();
    }
    function paint() {
      qa(root, '.jdgm-rev').forEach(function (rev) {
        var ic = q(rev, '.jdgm-rev__icon');
        if (!ic || ic.__n1a) return;
        ic.__n1a = true;
        if (ic.children.length || (ic.textContent || '').trim()) return; // já tem foto ou letra
        var au = q(rev, '.jdgm-rev__author');
        var ini = iniciais(au ? au.textContent : '');
        if (!ini) return;
        ic.textContent = ini;
        ic.setAttribute('aria-hidden', 'true');
        ic.classList.add('n1a-avatar');
      });
    }
    paint();
    new MutationObserver(paint).observe(root, { childList: true, subtree: true });
  }

  /* ================= Info popups (size guides, guarantee, glove care) ================= */
  function initModals() {
    var root = q(document, '[data-n1a-modals]'); if (!root || root.__n1a) return;
    root.__n1a = true;
    qa(root, '.n1m').forEach(function (m) { document.body.appendChild(m); });
    var open = null, lastFocus = null, hideTimer = null;
    function focusables(m) { return qa(m, 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(function (el) { return el.offsetParent !== null; }); }
    function show(key, opener) {
      var m = document.querySelector('.n1m[data-n1a-modal="' + key + '"]'); if (!m) return false;
      if (open && open !== m) hide(true);
      clearTimeout(hideTimer); open = m; lastFocus = opener || document.activeElement;
      m.hidden = false; document.body.classList.add('n1m-lock');
      highlightSize(m); pickTab(m);
      setTimeout(function () { m.classList.add('is-open'); var c = q(m, '.n1m-close'); if (c) c.focus(); }, 15);
      return true;
    }
    function hide(fast) {
      if (!open) return; var m = open; open = null;
      m.classList.remove('is-open'); document.body.classList.remove('n1m-lock');
      var done = function () { m.hidden = true; };
      if (fast) done(); else hideTimer = setTimeout(done, 240);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    }
    function highlightSize(m) {
      var t = q(m, '[data-n1a-sizes]'); if (!t) return;
      var sel = document.querySelector('.product-single__form input[type="radio"][name="Size"]:checked');
      var v = sel ? sel.value.trim() : '';
      qa(t, 'tr[data-size]').forEach(function (r) { r.classList.toggle('is-current', !!v && r.getAttribute('data-size') === v); });
    }
    function pickTab(m) {
      var tabs = q(m, '[data-n1m-tabs]'); if (!tabs || tabs.__n1aPicked) return; tabs.__n1aPicked = true;
      var def = m.getAttribute('data-default-tab'); var b = def ? q(tabs, '[data-n1m-tab="' + def + '"]') : null;
      if (b) selectTab(tabs, b);
    }
    function selectTab(tabs, b) {
      var key = b.getAttribute('data-n1m-tab');
      qa(tabs, '[data-n1m-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      qa(tabs.closest('.n1m'), '[data-n1m-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-n1m-pane') !== key; });
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-n1a-open]');
      if (o) { e.preventDefault(); e.stopPropagation(); show(o.getAttribute('data-n1a-open'), o); return; }
      var c = e.target.closest('[data-n1a-close]');
      if (c) { e.preventDefault(); hide(); return; }
      var tb = e.target.closest('[data-n1m-tab]');
      if (tb) { e.preventDefault(); selectTab(tb.closest('[data-n1m-tabs]'), tb); return; }
      if (open && e.target === open) hide();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
      if (e.key === 'Tab') {
        var f = focusables(open); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.__n1aOpenModal = show; // test hook
  }

  /* ================= Trava de "adicionar ao carrinho" =================
     Tem de funcionar SEMPRE, mesmo que a camada visual não chegue a montar: como escondemos o contentor
     da app nas luvas, a validação dela deixa de travar, e sem esta trava era possível comprar um Glove ID
     sem nome. Por isso vive fora do mount, corre em captura no documento (antes do tema, do carrinho fixo
     e da app) e olha diretamente para os campos obrigatórios da app. */
  var ATC_SEL = '[data-add-to-cart], button[name="add"], input[name="add"], .add-to-cart, [data-cart-submit]';
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); }
  function ioContainer(form) { return form ? q(form, '[id^="infiniteoptions-container"]') : null; }
  function ioMissing(form) {
    var c = ioContainer(form); if (!c) return null;
    var bad = qa(c, 'input[type="text"], textarea, select').filter(function (i) {
      if (!(i.required || i.getAttribute('aria-required') === 'true')) return false;
      if (i.value && i.value.trim()) return false;
      return i.offsetParent !== null; // campos que a app esconde (lógica condicional) não contam
    });
    return bad.length ? { container: c, fields: bad } : null;
  }
  function formOf(el) {
    return (el && el.closest && el.closest('form')) || q(document, 'form.product-single__form') || q(document, 'form[action*="/cart/add"]');
  }
  function guardCheck(e, target) {
    var btn = target && target.closest ? target.closest(ATC_SEL) : null; if (!btn) return;
    var form = formOf(btn); if (!form) return;
    var blk = q(form, '[data-n1-addons]');
    var vivo = blk && !blk.hidden && !blk.classList.contains('is-busy') && typeof blk.__n1aValidate === 'function';
    if (vivo) { if (!blk.__n1aValidate()) stop(e); return; }
    var miss = ioMissing(form); if (!miss) return;
    stop(e);
    // a camada não montou: devolver os campos originais e levar o cliente até eles
    miss.container.classList.remove('n1a-io-hidden');
    if (blk) blk.hidden = true;
    var f = miss.fields[0];
    try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) { }
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (_) { f.focus(); } }, 300);
  }
  function installGuard() {
    if (window.__n1AddonsGuard) return; window.__n1AddonsGuard = true;
    document.addEventListener('click', function (e) { guardCheck(e, e.target); }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Enter') guardCheck(e, e.target); }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target; if (!form || !form.matches || !form.matches('form')) return;
      var blk = q(form, '[data-n1-addons]');
      var vivo = blk && !blk.hidden && !blk.classList.contains('is-busy') && typeof blk.__n1aValidate === 'function';
      if (vivo) { if (!blk.__n1aValidate()) stop(e); return; }
      if (ioMissing(form)) stop(e);
    }, true);
  }

  function scan() {
    installGuard();
    initModals();
    qa(document, '.product-section.n1a-on').forEach(enhancePage);
    qa(document, '[data-n1-addons]').forEach(function (block) { enhancePage(block.closest('.product-section')); init(block); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { scan(); break; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
